import React, { useMemo } from "react";
import type { Column } from "@tanstack/react-table";
import ActionsMenu from "../../ActionsMenu/ActionsMenu";
import { IconButton } from "../../../controls";

interface TheadCellActionsProps {
  column?: Column<unknown, unknown>;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const TheadCellActions: React.FC<TheadCellActionsProps> = ({
  column,
  setIsActive,
}) => {
  const menuItems = useMemo(() => {
    const isPinned = column?.getIsPinned();
    const isRemoveDisabled = !column?.getCanHide();
    return [
      {
        onClick: () => (isPinned ? column?.pin(false) : column?.pin("left")),
        component: (
          <div className={"column-action pin-column-action"}>
            <i
              className={isPinned ? "seem-icon-pin-filled" : "seem-icon-pin"}
            />
            <span className="pin-column-action-text">
              {isPinned ? "Unpin Column" : "Pin Column"}
            </span>
          </div>
        ),
      },
      {
        disabled: isRemoveDisabled,
        onClick: () =>
          // The visibility handler expects an event; only `target.checked`
          // is read, so a minimal event-like object is passed.
          column?.getToggleVisibilityHandler()({
            target: { checked: false },
          } as unknown as React.ChangeEvent<HTMLInputElement>),
        tooltipData: {
          className: "default-column-tooltip",
          place: "top" as const,
          dataTip: isRemoveDisabled
            ? "This column is system-provided and cannot be removed"
            : null,
        },
        component: (
          <>
            <div className={"column-action remove-column-action"}>
              <i className="seem-icon-hide" />
              <span className="pin-column-action-text">Hide Column</span>
            </div>
          </>
        ),
      },
    ];
  }, [column?.getCanHide(), column?.getIsPinned()]);

  return (
    <>
      <ActionsMenu
        className={"column-actions"}
        menuItems={menuItems}
        onMenuOpenChange={(isOpen: boolean) => setIsActive(isOpen)}
      >
        <IconButton
          isIcon={"seem-icon seem-icon-more-actions column-actions-icon-button"}
          className={"column-actions-button"}
          data-testid={"more-actions-btn"}
          type="button"
        />
      </ActionsMenu>
    </>
  );
};

export default TheadCellActions;
